<template>
  <div class="ViewAboutCreditsItem">
    <div class="ViewAboutCreditsItem__header">
      <div
        class="ViewAboutCreditsItem__header-col ViewAboutCreditsItem__header-col--logo"
        v-if="item.logo"
      >
        <img
          :src="item.logo"
          :alt="item.name"
          decoding="async"
          class="ViewAboutCreditsItem__logo"
        />
      </div>
      <div
        class="ViewAboutCreditsItem__header-col"
        v-for="(headerItem, index) in item.headerItems"
        :key="index"
      >
        <div class="ViewAboutCreditsItem__header-value">
          {{ headerItem.value }}
        </div>
        <div class="ViewAboutCreditsItem__header-desc">
          {{ headerItem.description }}
        </div>
      </div>

      <div
        class="ViewAboutCreditsItem__header-col ViewAboutCreditsItem__header-col--btn"
      >
        <app-button-control
          :class="{ 'is-active': item.isOpen }"
          class="ViewAboutCreditsItem__btn ViewAboutCreditsItem__btn-header"
          type="secondary"
          @click="openContent(index)"
        >
          <span v-if="item.isOpen">Скрыть описание</span>
          <span v-else>Подробнее о продукте</span>

          <app-svg-icon
            isCurrentColor
            name="arrow-circle"
            class="ViewAboutCreditsItem__btn-icon"
          ></app-svg-icon>
        </app-button-control>
      </div>
    </div>

    <collapse-transition>
      <div class="ViewAboutCreditsItem__content" v-show="item.isOpen">
        <div class="ViewAboutCreditsItem__content-inner">
          <div class="ViewAboutCreditsItem__content-col-left">
            <div class="ViewAboutCreditsItem__description">
              <div
                class="ViewAboutCreditsItem__description-text"
                v-if="item.description"
              >
                {{ item.description }}
              </div>
              <app-button-control
                v-if="item.link"
                tag="a"
                target="_blank"
                :href="item.link"
                class="ViewAboutCreditsItem__btn"
                type="secondary"
              >
                {{ item.linkText }}
                <app-svg-icon
                  name="arrow-type-2"
                  class="ViewAboutCreditsItem__btn-icon ViewAboutCreditsItem__btn-icon--small"
                ></app-svg-icon>
              </app-button-control>
            </div>

            <div class="ViewAboutCreditsItem__answers" v-if="item.pdf">
              <h5 class="ViewAboutCreditsItem__answers-title">
                Остались вопросы?
              </h5>
              <p class="ViewAboutCreditsItem__answers-desc">
                Посмотрите
                <a @click="openModalFile(item.pdf)"
                  >подробную инструкцию в PDF</a
                >
              </p>
            </div>
          </div>
          <div class="ViewAboutCreditsItem__content-col-right">
            <div class="ViewAboutCreditsItem__list">
              <div
                class="ViewAboutCreditsItem__list-item"
                v-for="(contentItem, index) in item.contentItems"
                :key="index"
              >
                <app-svg-icon
                  :name="contentItem.icon"
                  class="ViewAboutCreditsItem__list-item-icon"
                ></app-svg-icon>
                <div
                  class="ViewAboutCreditsItem__list-item-desc"
                  v-html="contentItem.title"
                ></div>
              </div>
            </div>
            <template v-if="item.isAlfaAdditional">
              <h2><strong>Условия:</strong></h2>
              <ul class="app-list-checked-red">
                <li>
                  ИП (граждане РФ старше 18 лет) или юрлица (только ООО -
                  резиденты РФ), зарегистрированные в соответствии с
                  законодательством РФ.
                </li>
                <li>Срок регистрации бизнеса — от 0 месяцев</li>
                <li>Рассрочка выдается на сумму от 10 000 до 1 000 000Р.</li>
                <li>Срок действия — 4 месяца.</li>
                <li>
                  До выдачи рассрочки нужно единоразово оплатить комиссию,
                  размер комиссии определяется индивидуально от 8%.
                </li>
                <li>
                  Погашение долга происходит ежемесячно равными платежами со
                  счета в Альфа-Банке
                </li>
                <li>
                  Бизнес-рассрочку можно оформить сколько угодно раз, но не
                  превышая доступный лимит.
                </li>
                <li>
                  Не должно быть открытых кредитных заявок. Сначала нужно
                  закончить оформление или отменить их в интернет-банке. После
                  сможете оформить новую.
                </li>
                <li>Количество учредителей не влияет на одобрение.</li>
                <li>
                  Лимит на продукт рассматривается индивидуально и зависит от
                  кредитного рейтинга, долговой нагрузки, объема выручки и срока
                  ведения бизнеса.
                </li>
              </ul>
              <h2><strong>Лимит будет меньше, при условиях:</strong></h2>
              <ul class="app-list-checked-red">
                <li>Срок регистрации бизнеса до 6 месяца</li>
                <li>Доля собственности ЕИО меньше 50%</li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions';
import AppPdfModal from '@/components/modal/AppPdfModal.vue';

export default {
  name: 'ViewAboutCredits',
  inject: ['responsive'],
  components: {
    CollapseTransition,
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.$options.BASE_URL = process.env.BASE_URL;
  },
  methods: {
    /**
     * Развернуть контент
     * @param {number} - index
     */
    openContent(index) {
      this.$emit('openContent', index);
    },

    /**
     * Открытие модального окна пдф файла
     * @param {String} - название файла
     */
    openModalFile(fileName) {
      this.$modal.show(
        AppPdfModal,
        {
          src: `${this.$options.BASE_URL}static/uploads/${fileName}`,
          contentType: 'application/pdf',
        },
        {
          name: 'app-pdf-modal',
          width: 900,
          height: '100%',
          adaptive: true,
          classes: 'app-pdf-modal__wrapper',
          class: 'app-pdf-modal',
        }
      );
    },
  },
};
</script>

<style lang="scss">
.ViewAboutCreditsItem {
  $root: &;
  $desktop_break: 1800px;

  background-color: $color-white;
  border-radius: 10px;
  box-shadow: $box-shadow-card-1;

  &__logo {
    display: block;
    max-width: 195px;
    max-height: 55px;
    margin: 0 auto;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 100%;
    padding: rem(25) rem(55);

    @media (max-width: $desktop_break) {
      padding: rem(25);
    }

    @media (max-width: $md) {
      flex-wrap: wrap;
    }

    @media (max-width: $sm) {
      padding: rem(15) rem(20);
    }
  }

  &__header-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    min-width: 0;
    padding: 0 rem(5);
    border-left: solid 1px $color-gray-13;

    &--btn {
      @media (max-width: $desktop_break) {
        width: 120%;
      }
    }

    &:last-child,
    &:first-child,
    &:nth-child(2) {
      border: none;
    }

    @media (max-width: $md) {
      align-items: center;
      width: 50%;
      padding: 5px 0;
      border-left: none;

      &:first-child {
        width: 100%;
      }
    }

    @media (max-width: $sm) {
      width: 100%;
      border-top: solid 1px $color-gray-13;
    }
  }

  &__btn {
    height: 45px !important;
    padding: 0 15px !important;
    margin: 0 auto;
    line-height: 1.3;

    @media (max-width: 1440px) {
      font-size: 12px;
    }
  }

  &__btn-icon {
    @include size(16px);

    margin-top: -0.13em;
    fill: $white;
    transition: transform 0.3s linear;
    will-change: transform;

    &:last-child {
      margin-left: rem(10);
    }

    &--small {
      @include size(14px);
    }
  }

  &__btn-header {
    min-width: 100%;
    padding: 0 5px !important;

    &.is-active {
      color: $color-brand-green !important;
      background: transparent;
      border: solid 1px $color-brand-green;
      #{$root}__btn-icon {
        fill: $color-brand-green;
        transform: rotate(-180deg);
      }

      &:hover {
        color: $white !important;
        border-color: transparent;
        #{$root}__btn-icon {
          fill: $white;
        }
      }
    }
  }

  &__header-value {
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: 700;
    text-align: center;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__header-desc {
    font-size: 14px;
    line-height: 1.3;
    color: $gray;
    text-align: center;

    @media (max-width: $desktop_break) {
      font-size: 12px;
    }
  }

  &__content-inner {
    display: flex;
    padding: rem(30) rem(60);
    border-top: solid 1px $color-gray-13;

    @media (max-width: $desktop_break) {
      padding: rem(30);
    }

    @media (max-width: $md) {
      flex-wrap: wrap;
    }

    @media (max-width: $sm) {
      padding: rem(15) rem(20);
    }
  }

  &__content-col-left {
    display: flex;
    flex-direction: column;
    width: 20%;

    @media (max-width: $desktop_break) {
      width: 30%;
    }

    @media (max-width: $md) {
      width: 100%;
      padding-right: 0;
    }
  }

  &__content-col-right {
    width: 80%;

    @media (max-width: $desktop_break) {
      width: 70%;
    }

    @media (max-width: $md) {
      width: 100%;
      padding-top: 40px;
    }
  }

  &__description-text {
    max-width: 80%;
    margin-bottom: rem(20);
    font-size: rem(14);
    text-wrap: balance;

    &:last-child {
      margin-bottom: 0;
    }

    @media (max-width: $sm) {
      max-width: 100%;
      text-align: center;
    }
  }

  &__description {
    margin-bottom: rem(30);

    @media (max-width: $sm) {
      display: flex;
      flex-direction: column;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__description-btn-icon {
    width: 16px;
    height: 16px;

    &:last-child {
      margin-left: 15px;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: rem(-30);

    @media (max-width: $sm) {
      margin-bottom: rem(-15);
    }
  }

  &__list-item {
    display: flex;
    flex-direction: column;
    width: 25%;
    margin-bottom: rem(30);
    text-align: center;

    @media (max-width: $sm) {
      flex: 1;
      width: 50%;
      margin-bottom: rem(15);
    }
  }

  &__list-item-desc {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    padding: 15px;
    margin: 0 5px;
    font-size: rem(13);
    font-weight: 500;
    line-height: 1.4;
    text-wrap: balance;
    background: #fafafa;
    border-radius: 7px;
  }

  &__list-item-icon {
    @include size(36px);

    margin: 0 auto rem(20);
  }

  &__answers {
    margin-top: auto;

    @media (max-width: $sm) {
      text-align: center;
    }

    a {
      color: $color-brand-green;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  &__answers-title {
    margin: 0 0 5px 0;
    font-size: 16px;
    font-weight: 700;
  }

  &__answers-desc {
    margin: 0;
    font-size: rem(14);
  }
}
</style>
